import { useAuth } from '@/hooks/useAuth';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { AlertTriangle, Clock, UserX, Calendar, LogOut } from 'lucide-react';
import logoTdtp from '@/assets/logo-tdtp.jpeg';

export function AccessBlockedScreen() {
  const { accessStatus, signOut } = useAuth();

  if (!accessStatus) return null;

  const getBlockReason = () => {
    if (!accessStatus.isActive) {
      return {
        icon: <UserX className="h-16 w-16 text-destructive" />,
        title: 'Cuenta Desactivada',
        description: 'Tu cuenta ha sido desactivada permanentemente.',
        details: accessStatus.suspensionReason || 'Contacta al administrador para más información.',
      };
    }
    if (accessStatus.isSuspended && accessStatus.suspendedUntil) {
      const suspendedDate = new Date(accessStatus.suspendedUntil);
      return {
        icon: <Clock className="h-16 w-16 text-warning" />,
        title: 'Cuenta Suspendida Temporalmente',
        description: `Tu acceso está suspendido hasta el ${suspendedDate.toLocaleDateString('es-ES', {
          weekday: 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        })}.`,
        details: accessStatus.suspensionReason || 'Podrás volver a acceder después de esa fecha.',
      };
    }
    if (accessStatus.accessExpired && accessStatus.accessExpiresAt) {
      return {
        icon: <Calendar className="h-16 w-16 text-destructive" />,
        title: 'Acceso Expirado',
        description: 'Tu período de acceso ha finalizado.',
        details: 'Contacta al administrador para renovar tu acceso a la plataforma.',
      };
    }
    return null;
  };

  const blockInfo = getBlockReason();
  if (!blockInfo) return null;

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <Card className="w-full max-w-md text-center">
        <CardHeader className="space-y-4">
          <div className="flex justify-center">
            <img 
              src={logoTdtp} 
              alt="Tu Dinero, Tu Poder" 
              className="h-20 w-20 rounded-xl object-cover"
            />
          </div>
          <div className="flex justify-center">
            {blockInfo.icon}
          </div>
          <CardTitle className="text-2xl">{blockInfo.title}</CardTitle>
          <CardDescription className="text-base">
            {blockInfo.description}
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="p-4 rounded-lg bg-muted">
            <p className="text-sm text-muted-foreground">
              {blockInfo.details}
            </p>
          </div>
          
          <div className="flex flex-col gap-3">
            <Button variant="outline" onClick={signOut} className="w-full gap-2">
              <LogOut className="h-4 w-4" />
              Cerrar Sesión
            </Button>
            <p className="text-xs text-muted-foreground">
              Si crees que esto es un error, contacta a tu mentor.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}